var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMethodoDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 47 39",
    id: "svg25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, "Methodo_Documents") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TaxAnalytics_Desk_FEC_01",
    transform: "translate(-172.000000, -1818.000000)",
    stroke: "white"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MISSION",
    transform: "translate(158.000000, 1698.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Methodo_Documents",
    transform: "translate(15.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-17",
    d: "M 36.9,15.3559 H 41 v -10.52 h -4.1 z m 4.0995,14.3666 c 0,1.132 -0.918,2.05 -2.05,2.05 -1.132,0 -2.05,-0.918 -2.05,-2.05 0,-1.132 0.918,-2.05 2.05,-2.05 1.132,0 2.05,0.918 2.05,2.05 z M 32.8,35.8619 H 45.1 V 0.9999 H 32.8 Z m 4.0692,-12.2858 h 4.161 z m 0,-4.1006 h 4.161 z m -11.5401,-3.4805 -3.958,-1.066 2.737,-10.158 3.958,1.068 z m -3.7382,13.8721 c -0.294,1.093 -1.419,1.74 -2.513,1.446 -1.093,-0.295 -1.74,-1.42 -1.445,-2.512 0.294,-1.094 1.419,-1.742 2.512,-1.447 1.093,0.295 1.741,1.42 1.446,2.513 z M 12.3228,32.745 21.1478,0 32.7998,3.141 21.1478,0 Z m 20.4946,-28.7793 -8.865,32.896 -11.609,-3.128 11.609,3.128 z m -12.5483,14.9326 4.018,1.083 z m -1.0669,3.959 4.018,1.082 z M 4.1,15.3559 H 8.2 V 4.8359 H 4.1 Z m 4.0997,14.3666 c 0,1.132 -0.917,2.05 -2.05,2.05 -1.132,0 -2.05,-0.918 -2.05,-2.05 0,-1.132 0.918,-2.05 2.05,-2.05 1.133,0 2.05,0.918 2.05,2.05 z M 0,35.8619 H 12.3 V 0.9999 H 0 Z M 4.0694,23.5761 h 4.161 z m 0,-4.1006 h 4.161 z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMethodoDocuments);
export default __webpack_public_path__ + "static/media/Methodo_Documents.13ce8a34d855ae5d2d3a416acdb9b35a.svg";
export { ForwardRef as ReactComponent };